/**
 * AdminAPI.js
 *
 * Funções de API para o módulo "Admin Geral" (plataforma).
 * Separado do API.js principal para manter o arquivo principal gerenciável.
 * Modelado em FiscalAPI.js.
 */

import { getAccessToken } from './authTokens';

export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://www.gabriela.app.br/api/';

// Endpoints admin
const ADMIN_COMPANIES_LIST           = BASE_URL + 'admin/companies/list.php';
const ADMIN_COMPANIES_GET            = BASE_URL + 'admin/companies/get.php';
const ADMIN_COMPANIES_SET_TEST       = BASE_URL + 'admin/companies/set_test.php';
const ADMIN_COMPANIES_DELETE_PREVIEW = BASE_URL + 'admin/companies/delete_preview.php';
const ADMIN_COMPANIES_DELETE         = BASE_URL + 'admin/companies/delete.php';
const ADMIN_COMPANIES_CLOSURE_START  = BASE_URL + 'admin/companies/closure_start.php';
const ADMIN_COMPANIES_CLOSURE_ARCHIVE = BASE_URL + 'admin/companies/closure_archive.php';
const ADMIN_COMPANIES_CLOSURE_ARCHIVE_DOWNLOAD = BASE_URL + 'admin/companies/closure_archive_download.php';
const ADMIN_COMPANIES_SEND_MESSAGE   = BASE_URL + 'admin/companies/send_message.php';
const ADMIN_COMPANIES_REOPEN_TRIAL   = BASE_URL + 'admin/companies/reopen_trial.php';
const ADMIN_COMPANIES_REFERRAL_REWARD = BASE_URL + 'admin/companies/referral_mark_rewarded.php';
const ADMIN_COMPANIES_REFERRAL_CONFIRM = BASE_URL + 'admin/companies/referral_confirm.php';
const ADMIN_COMPANIES_DEMO_SEED = BASE_URL + 'admin/companies/demo_seed.php';
const ADMIN_COMPANIES_DEMO_REMOVE = BASE_URL + 'admin/companies/demo_remove.php';
const ADMIN_AUDIT_LIST               = BASE_URL + 'admin/audit/list.php';
const ADMIN_CRONS_STATUS             = BASE_URL + 'admin/crons/status.php';
const ADMIN_CRONS_RUN_NOW            = BASE_URL + 'admin/crons/run_now.php';
const ADMIN_FEEDBACKS_LIST           = BASE_URL + 'admin/feedbacks/list.php';
const ADMIN_FEEDBACKS_NPS_LIST       = BASE_URL + 'admin/feedbacks/nps_list.php';
const ADMIN_FEEDBACKS_GET            = BASE_URL + 'admin/feedbacks/get.php';
const ADMIN_FEEDBACKS_SET_STATUS     = BASE_URL + 'admin/feedbacks/set_status.php';
const ADMIN_FEEDBACKS_REVIEW         = BASE_URL + 'admin/feedbacks/review.php';
const ADMIN_FEEDBACKS_RELEASE_FIXED  = BASE_URL + 'admin/feedbacks/release_fixed.php';
const ADMIN_FEEDBACKS_GET_FILE       = BASE_URL + 'admin/feedbacks/get_file.php';
const ADMIN_SECURITY_BLOCKED_IPS     = BASE_URL + 'admin/security/blocked_ips.php';
const ADMIN_SECURITY_UNBLOCK_IP      = BASE_URL + 'admin/security/unblock_ip.php';
const ADMIN_LOGS_DAYS                = BASE_URL + 'admin/logs/days.php';
const ADMIN_LOGS_SUMMARY             = BASE_URL + 'admin/logs/summary.php';
const ADMIN_LOGS_LIST                = BASE_URL + 'admin/logs/list.php';
const ADMIN_LOGS_PHP_TAIL            = BASE_URL + 'admin/logs/php_tail.php';
const ADMIN_BACKUPS_LIST             = BASE_URL + 'admin/backups/list.php';
const ADMIN_BACKUPS_DOWNLOAD         = BASE_URL + 'admin/backups/download.php';
const ADMIN_BACKUPS_REMOTE_STATUS    = BASE_URL + 'admin/backups/remote_status.php';
const ADMIN_SIGNUPS_LIST             = BASE_URL + 'admin/signups/list.php';
const ADMIN_SIGNUPS_RESEND           = BASE_URL + 'admin/signups/resend.php';
const ADMIN_TUTORIALS_STATS          = BASE_URL + 'admin/tutorials/stats.php';
const ADMIN_CHANGELOG_ITEMS          = BASE_URL + 'admin/changelog/items.php';
const ADMIN_CHANGELOG_ITEM_SAVE      = BASE_URL + 'admin/changelog/item_save.php';
const ADMIN_CHANGELOG_ITEM_STATUS    = BASE_URL + 'admin/changelog/item_status.php';
const ADMIN_CHANGELOG_EDITIONS       = BASE_URL + 'admin/changelog/editions.php';
const ADMIN_CHANGELOG_EDITION        = BASE_URL + 'admin/changelog/edition.php';
const ADMIN_CHANGELOG_EDITION_SAVE   = BASE_URL + 'admin/changelog/edition_save.php';
const ADMIN_CHANGELOG_EDITION_SCHEDULE = BASE_URL + 'admin/changelog/edition_schedule.php';
const ADMIN_CHANGELOG_EDITION_SEND_NOW = BASE_URL + 'admin/changelog/edition_send_now.php';
const ADMIN_CHANGELOG_EDITION_CANCEL = BASE_URL + 'admin/changelog/edition_cancel.php';
const ADMIN_CHANGELOG_PREVIEW        = BASE_URL + 'admin/changelog/preview.php';
const ADMIN_CHANGELOG_RECIPIENTS     = BASE_URL + 'admin/changelog/recipients.php';
const ADMIN_CHANGELOG_MEDIA          = BASE_URL + 'admin/changelog/media.php';
const ADMIN_CHANGELOG_MEDIA_UPLOAD   = BASE_URL + 'admin/changelog/media_upload.php';
const ADMIN_ONBOARDING_TEMPLATES     = BASE_URL + 'admin/onboarding/templates.php';
const ADMIN_ONBOARDING_TEMPLATE_SAVE = BASE_URL + 'admin/onboarding/template_save.php';
const ADMIN_ONBOARDING_SETTINGS_SAVE = BASE_URL + 'admin/onboarding/settings_save.php';
const ADMIN_ONBOARDING_PREVIEW       = BASE_URL + 'admin/onboarding/preview.php';
const ADMIN_ONBOARDING_SIMULATION    = BASE_URL + 'admin/onboarding/simulation.php';
const ADMIN_SUBSCRIPTIONS_OVERVIEW   = BASE_URL + 'admin/subscriptions/overview.php';
const ADMIN_WHATSAPP_OVERVIEW        = BASE_URL + 'admin/whatsapp/overview.php';
const ADMIN_WHATSAPP_COMPANIES       = BASE_URL + 'admin/whatsapp/companies.php';
const ADMIN_WHATSAPP_OUTBOX          = BASE_URL + 'admin/whatsapp/outbox.php';
const ADMIN_TRIAL_OUTREACH_HISTORY   = BASE_URL + 'admin/trial_outreach/history.php';
const ADMIN_TRIAL_OUTREACH_GET_OUTCOME = BASE_URL + 'admin/trial_outreach/get_outcome.php';
const ADMIN_TRIAL_OUTREACH_SET_OUTCOME = BASE_URL + 'admin/trial_outreach/set_outcome.php';
const ADMIN_PROSPECTS_LIST          = BASE_URL + 'admin/prospects/list.php';
const ADMIN_PROSPECTS_SAVE          = BASE_URL + 'admin/prospects/save.php';
const ADMIN_PROSPECTS_MESSAGES      = BASE_URL + 'admin/prospects/messages.php';
const ADMIN_PROSPECTS_LOG_MESSAGE   = BASE_URL + 'admin/prospects/log_message.php';
const ADMIN_PROSPECTS_SEND_WHATSAPP = BASE_URL + 'admin/prospects/send_whatsapp.php';
const ADMIN_PROSPECTS_SET_STATUS    = BASE_URL + 'admin/prospects/set_status.php';
const ADMIN_PROSPECTS_SEARCH_PLACES = BASE_URL + 'admin/prospects/search_places.php';
const ADMIN_PROSPECTS_IMPORT        = BASE_URL + 'admin/prospects/import.php';

// ─── Helpers internos ────────────────────────────────────────────────────────

const getToken = () => getAccessToken();

const callGet = (url, callback) => {
    fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${getToken()}`,
            'Content-Type': 'application/json',
        },
    })
        .then(res => res.json())
        .then(data => callback(data))
        .catch(err => callback({ success: false, error: err.message || 'Erro de conexão' }));
};

const callPostJson = (url, body, callback) => {
    fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${getToken()}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
        .then(res => res.json())
        .then(data => callback(data))
        .catch(err => callback({ success: false, error: err.message || 'Erro de conexão' }));
};

// Upload multipart: sem Content-Type, o navegador monta o boundary
const callPostForm = (url, formData, callback) => {
    fetch(url, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${getToken()}` },
        body: formData,
    })
        .then(res => res.json())
        .then(data => callback(data))
        .catch(err => callback({ success: false, error: err.message || 'Erro de conexão' }));
};

/**
 * Monta uma query string a partir de um objeto, ignorando valores undefined/null.
 * @param {Object} params
 * @returns {string}
 */
const buildQuery = (params = {}) => {
    const query = Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    return query ? `?${query}` : '';
};

// ─── API pública ─────────────────────────────────────────────────────────────

/**
 * Lista empresas (visão Admin Geral) com filtros, ordenação e paginação.
 * @param {{ search?: string, status?: string, is_test?: string, sort?: string, order?: string, page?: number, limit?: number }} params
 * @param {Function} callback
 */
export const GetAdminCompaniesAPI = (params = {}, callback) => {
    callGet(ADMIN_COMPANIES_LIST + buildQuery(params), callback);
};

/**
 * Retorna os detalhes de uma empresa (visão Admin Geral).
 * @param {number|string} id
 * @param {Function} callback
 */
export const GetAdminCompanyAPI = (id, callback) => {
    callGet(ADMIN_COMPANIES_GET + buildQuery({ id }), callback);
};

/**
 * Marca ou desmarca uma empresa como "teste".
 * @param {number|string} companyId
 * @param {boolean} isTest
 * @param {Function} callback
 */
export const SetAdminCompanyTestAPI = (companyId, isTest, callback) => {
    callPostJson(ADMIN_COMPANIES_SET_TEST, { company_id: companyId, is_test: isTest ? 1 : 0 }, callback);
};

/**
 * Retorna a prévia de exclusão de uma empresa (bloqueios, avisos e resumo de dados).
 * @param {number|string} id
 * @param {Function} callback
 */
export const GetAdminCompanyDeletePreviewAPI = (id, callback) => {
    callGet(ADMIN_COMPANIES_DELETE_PREVIEW + buildQuery({ id }), callback);
};

/**
 * Exclui permanentemente uma empresa e todos os seus dados.
 * @param {number|string} companyId
 * @param {string} confirmationName - Nome exato da empresa, digitado pelo admin para confirmar
 * @param {Function} callback
 */
export const DeleteAdminCompanyAPI = (companyId, confirmationName, callback) => {
    callPostJson(ADMIN_COMPANIES_DELETE, { company_id: companyId, confirmation_name: confirmationName }, callback);
};

/**
 * Inicia o encerramento da conta de uma empresa (origem 'admin', carência de 90 dias).
 * @param {number|string} companyId
 * @param {Function} callback
 */
export const StartAdminCompanyClosureAPI = (companyId, callback) => {
    callPostJson(ADMIN_COMPANIES_CLOSURE_START, { company_id: companyId }, callback);
};

/**
 * Envia uma mensagem avulsa para uma empresa pelos canais da Gabriela (e-mail ou WhatsApp).
 * O destinatário é a `key` de um contato de `company.message_contacts` (get.php), nunca texto livre.
 * @param {{ company_id: number|string, channel: 'email'|'whatsapp', recipient: string, subject?: string, message: string }} payload
 * @param {Function} callback
 */
export const SendAdminCompanyMessageAPI = (payload, callback) => {
    callPostJson(ADMIN_COMPANIES_SEND_MESSAGE, payload, callback);
};

/**
 * Libera um novo período de teste (14 dias a partir de agora) para uma empresa sem
 * assinatura vigente e com o teste vencido. Fecha o encerramento aberto, se houver.
 * @param {number|string} companyId
 * @param {Function} callback recebe { success, trial_ends_at, days, closure_reverted } ou { success: false, error }
 */
export const ReopenAdminCompanyTrialAPI = (companyId, callback) => {
    callPostJson(ADMIN_COMPANIES_REOPEN_TRIAL, { company_id: companyId }, callback);
};

/**
 * Situação do arquivo de segurança do encerramento em andamento.
 * @param {number|string} companyId
 * @param {Function} callback
 */
export const GetAdminCompanyClosureArchiveAPI = (companyId, callback) => {
    callGet(ADMIN_COMPANIES_CLOSURE_ARCHIVE + buildQuery({ company_id: companyId }), callback);
};

/**
 * Gera o arquivo de segurança do encerramento (só com a carência vencida).
 * @param {number|string} companyId
 * @param {Function} callback
 */
export const CreateAdminCompanyClosureArchiveAPI = (companyId, callback) => {
    callPostJson(ADMIN_COMPANIES_CLOSURE_ARCHIVE, { company_id: companyId }, callback);
};

/**
 * Link assinado de uma parte do arquivo de segurança (o download é registrado na auditoria).
 * @param {number|string} companyId
 * @param {number} part - Índice da parte, a partir de 0
 * @param {Function} callback - recebe { success, url, name, size }
 */
export const GetAdminClosureArchiveDownloadUrlAPI = (companyId, part, callback) => {
    callGet(ADMIN_COMPANIES_CLOSURE_ARCHIVE_DOWNLOAD + buildQuery({ company_id: companyId, part, mode: 'url' }), callback);
};

/**
 * Lista o log de auditoria de ações administrativas (platform_admin_audit_log).
 * @param {{ action?: string, company?: string|number, search?: string, date_from?: string, date_to?: string, page?: number, limit?: number }} params
 * @param {Function} callback
 */
export const GetAdminAuditLogAPI = (params = {}, callback) => {
    callGet(ADMIN_AUDIT_LIST + buildQuery(params), callback);
};

/**
 * Retorna o status de saúde das rotinas automáticas (crons): última execução, resultado
 * (lido dos logs do canal "cron"), lock e artefato (backup mais recente), por script.
 * @param {Function} callback
 */
export const GetAdminCronsStatusAPI = (callback) => {
    callGet(ADMIN_CRONS_STATUS, callback);
};

/**
 * Dispara uma rotina (cron) na hora, em segundo plano, pelo mesmo cron_runner do crontab.
 * Responde 409 se o lock da rotina estiver ativo (ela já está rodando).
 * @param {string} script - nome do script, como vem em status.php (ex.: send_nps_message.php)
 * @param {Function} callback
 */
export const RunAdminCronNowAPI = (script, callback) => {
    callPostJson(ADMIN_CRONS_RUN_NOW, { script, confirm: true }, callback);
};

/**
 * Lista feedbacks (problemas/melhorias) com filtros e paginação.
 * @param {{ type?: string, status?: string, search?: string, page?: number, limit?: number }} params
 * @param {Function} callback
 */
export const GetAdminFeedbacksAPI = (params = {}, callback) => {
    callGet(ADMIN_FEEDBACKS_LIST + buildQuery(params), callback);
};

/**
 * Lista avaliações NPS com filtros e paginação.
 * @param {{ status?: string, search?: string, page?: number, limit?: number }} params
 * @param {Function} callback
 */
export const GetAdminNpsAPI = (params = {}, callback) => {
    callGet(ADMIN_FEEDBACKS_NPS_LIST + buildQuery(params), callback);
};

/**
 * Retorna os detalhes de um feedback ou avaliação NPS, incluindo anexos.
 * @param {'feedback'|'nps'} type
 * @param {number|string} id
 * @param {Function} callback
 */
export const GetAdminFeedbackItemAPI = (type, id, callback) => {
    callGet(ADMIN_FEEDBACKS_GET + buildQuery({ type, id }), callback);
};

/**
 * Atualiza o status de um feedback ou avaliação NPS.
 * @param {'feedback'|'nps'} type
 * @param {number|string} id
 * @param {string} status
 * @param {Function} callback
 */
export const SetAdminFeedbackStatusAPI = (type, id, status, callback) => {
    callPostJson(ADMIN_FEEDBACKS_SET_STATUS, { type, id, status }, callback);
};

/**
 * Salva a revisão de um pedido (status, classificação, prioridade, notas, resposta, commit).
 * Disponível, respondido e no roadmap avisam quem enviou (sino + e-mail).
 * @param {number|string} id
 * @param {Object} review
 * @param {Function} callback - { success, item, notified: { bell, email } | null }
 */
export const ReviewAdminFeedbackAPI = (id, review, callback) => {
    callPostJson(ADMIN_FEEDBACKS_REVIEW, { id, ...review }, callback);
};

/**
 * Libera todos os pedidos corrigidos (depois do deploy) e avisa cada usuário.
 * @param {Function} callback - { success, released, notified }
 */
export const ReleaseFixedAdminFeedbacksAPI = (callback) => {
    callPostJson(ADMIN_FEEDBACKS_RELEASE_FIXED, {}, callback);
};

/**
 * Lista os IPs atualmente bloqueados ou com histórico de bloqueio (rate limit).
 * @param {Function} callback
 */
export const GetAdminBlockedIpsAPI = (callback) => {
    callGet(ADMIN_SECURITY_BLOCKED_IPS, callback);
};

/**
 * Libera um IP bloqueado, removendo os arquivos de controle de bloqueio/rate limit.
 * @param {string} ip
 * @param {Function} callback
 */
export const UnblockAdminIpAPI = (ip, callback) => {
    callPostJson(ADMIN_SECURITY_UNBLOCK_IP, { ip }, callback);
};

/**
 * Lista os dias com logs disponíveis (mais recente primeiro), com os canais existentes
 * em cada dia, tamanho em bytes e os níveis de severidade suportados.
 * @param {Function} callback
 */
export const GetAdminLogDaysAPI = (callback) => {
    callGet(ADMIN_LOGS_DAYS, callback);
};

/**
 * Retorna o resumo agregado (digest) dos logs de um dia: totais por nível, por canal,
 * top erros, segurança e comparação com o dia anterior.
 * @param {string} date - YYYY-MM-DD
 * @param {Function} callback
 */
export const GetAdminLogSummaryAPI = (date, callback) => {
    callGet(ADMIN_LOGS_SUMMARY + buildQuery({ date }), callback);
};

/**
 * Lista as linhas de log de um dia, com filtros e paginação.
 * @param {{ date: string, channel?: string, level?: string, company?: string|number, req?: string, q?: string, page?: number, limit?: number }} params
 * @param {Function} callback
 */
export const GetAdminLogsAPI = (params = {}, callback) => {
    callGet(ADMIN_LOGS_LIST + buildQuery(params), callback);
};

/**
 * Retorna as últimas linhas de php.log (log nativo do PHP, texto livre) de um dia.
 * @param {string} date - YYYY-MM-DD
 * @param {number} lines - quantidade de linhas (default 200, máx 1000)
 * @param {Function} callback
 */
export const GetAdminPhpLogTailAPI = (date, lines, callback) => {
    callGet(ADMIN_LOGS_PHP_TAIL + buildQuery({ date, lines }), callback);
};

/**
 * Lista os backups de banco de dados disponíveis (gerados pela rotina automática).
 * @param {Function} callback
 */
export const GetAdminBackupsAPI = (callback) => {
    callGet(ADMIN_BACKUPS_LIST, callback);
};

/**
 * Status do backup remoto (bucket S3 / Backblaze B2): banco e uploads.
 * Só leitura, mesma fonte usada pelo digest diário (BackupStatusReader.php).
 * @param {Function} callback
 */
export const GetAdminBackupsRemoteStatusAPI = (callback) => {
    callGet(ADMIN_BACKUPS_REMOTE_STATUS, callback);
};

/**
 * Baixa um anexo de feedback como Blob. O endpoint é protegido (sem URL
 * pública): responde com o arquivo ou com 302 para o bucket, que o fetch
 * segue sozinho.
 * @param {number|string} id - id do anexo (files[].id de GetAdminFeedbackItemAPI)
 * @returns {Promise<Blob>}
 */
export const GetAdminFeedbackFileAPI = (id) => {
    return fetch(ADMIN_FEEDBACKS_GET_FILE + buildQuery({ id }), {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${getToken()}`,
        },
    })
        .then(res => {
            if (!res.ok) {
                return res.json()
                    .catch(() => null)
                    .then(data => {
                        throw new Error(data?.error || 'Erro ao abrir o anexo. Tente novamente.');
                    });
            }
            return res.blob();
        });
};

/**
 * Faz o download de um arquivo de backup do banco de dados.
 * Usa fetch com Authorization header (endpoint protegido) e dispara o download via blob.
 * @param {string} name - Nome do arquivo, conforme retornado por GetAdminBackupsAPI
 * @returns {Promise<void>}
 */
export const DownloadAdminBackupAPI = (name) => {
    return fetch(ADMIN_BACKUPS_DOWNLOAD + buildQuery({ name }), {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${getToken()}`,
        },
    })
        .then(res => {
            if (!res.ok) {
                return res.json()
                    .catch(() => null)
                    .then(data => {
                        throw new Error(data?.error || 'Erro ao baixar o backup. Tente novamente.');
                    });
            }
            return res.blob();
        })
        .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        });
};

/**
 * Lista cadastros pendentes (pending_signups) com filtros e paginação.
 * @param {{ status?: string, search?: string, page?: number, limit?: number }} params
 * @param {Function} callback
 */
export const GetAdminSignupsAPI = (params = {}, callback) => {
    callGet(ADMIN_SIGNUPS_LIST + buildQuery(params), callback);
};

/**
 * Reenvia o e-mail de confirmação de um cadastro pendente.
 * @param {number|string} id
 * @param {Function} callback
 */
export const ResendAdminSignupAPI = (id, callback) => {
    callPostJson(ADMIN_SIGNUPS_RESEND, { id }, callback);
};

/**
 * Números dos tutoriais por lição, somando todas as empresas.
 * @param {{ include_test?: number|string }} params
 * @param {Function} callback
 */
export const GetAdminTutorialsStatsAPI = (params = {}, callback) => {
    callGet(ADMIN_TUTORIALS_STATS + buildQuery(params), callback);
};

// ─── Novidades (docs/features/changelog/CATALOGO-E-ENVIOS.md) ────────────────

/**
 * Catálogo de novidades com busca, filtros e paginação.
 * @param {{ q?: string, status?: 'all'|'draft'|'published'|'internal', sent?: 'sim'|'nao'|'', type?: string, area?: string, page?: number, limit?: number }} params
 * @param {Function} callback - { success, items: [ITEM_ADMIN], pagination }
 */
export const GetAdminChangelogItemsAPI = (params = {}, callback) => {
    callGet(ADMIN_CHANGELOG_ITEMS + buildQuery(params), callback);
};

/**
 * Cria (sem id, com slug) ou edita uma novidade.
 * @param {Object} item - { id?, slug?, type, title, summary, area, link, cta, plan, highlight, item_date, internal_note, image_media_id }
 * @param {Function} callback - { success, item }
 */
export const SaveAdminChangelogItemAPI = (item, callback) => {
    callPostJson(ADMIN_CHANGELOG_ITEM_SAVE, item, callback);
};

/**
 * Muda o status de várias novidades de uma vez.
 * @param {{ ids: number[], status: 'published'|'draft'|'internal', notify_bell?: boolean }} body
 * @param {Function} callback - { success, changed, blocked: [{ id, reason }] }
 */
export const SetAdminChangelogItemStatusAPI = (body, callback) => {
    callPostJson(ADMIN_CHANGELOG_ITEM_STATUS, body, callback);
};

/**
 * Envios do e-mail de novidades (garante um em rascunho) e os destinatários estimados.
 * @param {Function} callback - { success, recipients_estimate, editions: [EDITION_SUMMARY] }
 */
export const GetAdminChangelogEditionsAPI = (callback) => {
    callGet(ADMIN_CHANGELOG_EDITIONS, callback);
};

/**
 * Um envio completo, com os itens na ordem.
 * @param {number} id
 * @param {Function} callback - { success, edition: EDITION_FULL }
 */
export const GetAdminChangelogEditionAPI = (id, callback) => {
    callGet(ADMIN_CHANGELOG_EDITION + buildQuery({ id }), callback);
};

/**
 * Grava um envio em rascunho ou agendado.
 * @param {Object} edition - { id, name, subject, preheader, intro, notify_bell, video_media_id, poster_media_id, captions_media_id, items: [{ item_id, position, highlight }] }
 * @param {Function} callback - { success, edition }
 */
export const SaveAdminChangelogEditionAPI = (edition, callback) => {
    callPostJson(ADMIN_CHANGELOG_EDITION_SAVE, edition, callback);
};

/**
 * Agenda um envio ("AAAA-MM-DD HH:MM") ou volta a rascunho (null).
 * Sem confirm e com aviso a resposta é { success: false, needs_confirm: true, warnings }.
 * @param {number} id
 * @param {string|null} scheduledAt
 * @param {boolean} confirm
 * @param {Function} callback - { success, edition, warnings }
 */
export const ScheduleAdminChangelogEditionAPI = (id, scheduledAt, confirm, callback) => {
    callPostJson(ADMIN_CHANGELOG_EDITION_SCHEDULE, { id, scheduled_at: scheduledAt, confirm: Boolean(confirm) }, callback);
};

/**
 * Envia agora: publica os itens, avisa no sino e enfileira os e-mails.
 * @param {number} id
 * @param {Function} callback - { success, queued, published_items }
 */
export const SendAdminChangelogEditionNowAPI = (id, callback) => {
    callPostJson(ADMIN_CHANGELOG_EDITION_SEND_NOW, { id, confirm: true }, callback);
};

/**
 * Cancela um envio em rascunho ou agendado.
 * @param {number} id
 * @param {Function} callback - { success }
 */
export const CancelAdminChangelogEditionAPI = (id, callback) => {
    callPostJson(ADMIN_CHANGELOG_EDITION_CANCEL, { id }, callback);
};

/**
 * HTML do e-mail de um envio. Com send=true também manda a prévia ao e-mail do admin.
 * @param {number} editionId
 * @param {boolean} send
 * @param {Function} callback - { success, subject, html, sent_to? }
 */
export const PreviewAdminChangelogEditionAPI = (editionId, send, callback, to = '') => {
    callPostJson(ADMIN_CHANGELOG_PREVIEW, { edition_id: editionId, send: Boolean(send), to }, callback);
};

/**
 * Prévia do e-mail com uma novidade só, como destaque ou na lista (nunca envia).
 * @param {Function} callback - { success, subject, html }
 */
export const PreviewAdminChangelogItemAPI = (itemId, highlight, callback) => {
    callPostJson(ADMIN_CHANGELOG_PREVIEW, { item_id: itemId, highlight: Boolean(highlight) }, callback);
};

/**
 * Destinatários de um envio, com abertura e clique (paginado).
 * @param {{ edition_id: number, q?: string, status?: string, opened?: 'sim'|'nao'|'', clicked?: 'sim'|'nao'|'', page?: number, limit?: number }} params
 * @param {Function} callback - { success, recipients, pagination }
 */
export const GetAdminChangelogRecipientsAPI = (params = {}, callback) => {
    callGet(ADMIN_CHANGELOG_RECIPIENTS + buildQuery(params), callback);
};

/**
 * Mídias já enviadas de um tipo.
 * @param {'image'|'video'|'poster'|'captions'} kind
 * @param {Function} callback - { success, media: [{ id, kind, label, original_name, size_bytes, url, created_at }] }
 */
export const GetAdminChangelogMediaAPI = (kind, callback) => {
    callGet(ADMIN_CHANGELOG_MEDIA + buildQuery({ kind }), callback);
};

/**
 * Sobe uma mídia (imagem, vídeo, capa ou legenda).
 * @param {File} file
 * @param {'image'|'video'|'poster'|'captions'} kind
 * @param {string} label
 * @param {Function} callback - { success, media }
 */
export const UploadAdminChangelogMediaAPI = (file, kind, label, callback) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('kind', kind);
    formData.append('label', label || '');
    callPostForm(ADMIN_CHANGELOG_MEDIA_UPLOAD, formData, callback);
};

// ─── E-mails de acompanhamento (docs/features/onboarding/README.md) ─────────

/**
 * Modelos da sequência com números, chave geral e as listas fixas do editor.
 * @param {Function} callback - { success, settings, tracks, stages, templates (com preheader, variant e sample_modes), targets, variables, blocks, skip_reasons }
 */
export const GetAdminOnboardingTemplatesAPI = (callback) => {
    callGet(ADMIN_ONBOARDING_TEMPLATES, callback);
};

/**
 * Salva um modelo.
 * @param {{ key: string, subject: string, preheader: string, body: string, button_label?: string, button_target?: string, plain: boolean, enabled: boolean }} template
 * @param {Function} callback - { success, template }
 */
export const SaveAdminOnboardingTemplateAPI = (template, callback) => {
    callPostJson(ADMIN_ONBOARDING_TEMPLATE_SAVE, template, callback);
};

/**
 * Liga ou desliga a sequência inteira.
 * @param {boolean} enabled
 * @param {Function} callback - { success, settings }
 */
export const SetAdminOnboardingSequenceAPI = (enabled, callback) => {
    callPostJson(ADMIN_ONBOARDING_SETTINGS_SAVE, { enabled: Boolean(enabled) }, callback);
};

/**
 * Prévia de um modelo (campos do editor, salvos ou não). Com send, envia só para "to".
 * @param {object} template - campos do editor; mode opcional (chave de sample_modes)
 * @param {boolean} send
 * @param {Function} callback - { success, subject, preheader, html, mode, sent_to? }
 * @param {string} to
 */
export const PreviewAdminOnboardingTemplateAPI = (template, send, callback, to = '') => {
    callPostJson(ADMIN_ONBOARDING_PREVIEW, { ...template, send: Boolean(send), to }, callback);
};

/**
 * Quem recebe o quê nos próximos dias, com o motivo de cada etapa (nada é gravado).
 * @param {boolean} assumeAllEnabled - considera todos os modelos ligados
 * @param {number} days - 7, 14 ou 30
 * @param {Function} callback - { success, days, assume_all_enabled, sequence_enabled, now, start, total, accounts (com events) }
 */
export const GetAdminOnboardingSimulationAPI = (assumeAllEnabled, days, callback) => {
    callGet(ADMIN_ONBOARDING_SIMULATION + buildQuery({ all: assumeAllEnabled ? 1 : '', days }), callback);
};

/**
 * Retorna a visão consolidada de assinaturas, trials e problemas de pagamento.
 * @param {{ include_test?: number|string, days_ahead?: number }} params
 * @param {Function} callback
 */
export const GetAdminSubscriptionsOverviewAPI = (params = {}, callback) => {
    callGet(ADMIN_SUBSCRIPTIONS_OVERVIEW + buildQuery(params), callback);
};

/**
 * Retorna a visão consolidada do WhatsApp da plataforma: status da instância compartilhada,
 * envios pela plataforma e empresas por origem (número da plataforma x número próprio).
 * @param {{ days?: number, include_test?: number|string }} params
 * @param {Function} callback
 */
export const GetAdminWhatsAppOverviewAPI = (params = {}, callback) => {
    callGet(ADMIN_WHATSAPP_OVERVIEW + buildQuery(params), callback);
};

/**
 * Lista as empresas com seu consumo de WhatsApp no período, com filtros, ordenação e paginação.
 * @param {{ days?: number, search?: string, origin?: string, include_test?: number|string, page?: number, limit?: number, sort?: string }} params
 * @param {Function} callback
 */
export const GetAdminWhatsAppCompaniesAPI = (params = {}, callback) => {
    callGet(ADMIN_WHATSAPP_COMPANIES + buildQuery(params), callback);
};

/**
 * Lista a fila de envio de WhatsApp (company_whatsapp_outbox) com resumo, filtros e paginação.
 * @param {{ status?: string, company?: string, automation_type?: string, message_kind?: string, priority?: number|string, date_from?: string, date_to?: string, late?: number|string, page?: number, limit?: number }} params
 * @param {Function} callback
 */
export const GetAdminWhatsAppOutboxAPI = (params = {}, callback) => {
    callGet(ADMIN_WHATSAPP_OUTBOX + buildQuery(params), callback);
};

/**
 * Histórico do contato com testes (rotina diária send_trial_outreach.php).
 * @param {{ limit?: number }} params
 * @param {Function} callback recebe { success, items } ou { success: false, error }
 */
export const GetAdminTrialOutreachHistoryAPI = (params = {}, callback) => {
    callGet(ADMIN_TRIAL_OUTREACH_HISTORY + buildQuery(params), callback);
};

/**
 * Resultado do contato marcado para uma empresa.
 * @param {number|string} companyId
 * @param {Function} callback recebe { success, outcome: { outcome, reason, note, at, by } | null }
 */
export const GetAdminTrialOutreachOutcomeAPI = (companyId, callback) => {
    callGet(ADMIN_TRIAL_OUTREACH_GET_OUTCOME + buildQuery({ company_id: companyId }), callback);
};

/**
 * Marca o resultado do contato (descartado tira a empresa da rotina).
 * @param {{ company_id: number|string, outcome: string, reason?: string, note?: string }} payload
 * @param {Function} callback recebe { success, outcome } ou { success: false, error }
 */
export const SetAdminTrialOutreachOutcomeAPI = (payload, callback) => {
    callPostJson(ADMIN_TRIAL_OUTREACH_SET_OUTCOME, payload, callback);
};

/**
 * Indique e ganhe: marca (ou desmarca) que o crédito de quem indicou esta conta foi aplicado no Stripe.
 * @param {number} companyId conta indicada
 * @param {boolean} rewarded
 * @param {Function} callback recebe { success, referral }
 */
export const MarkAdminCompanyReferralRewardedAPI = (companyId, rewarded, callback) => {
    callPostJson(ADMIN_COMPANIES_REFERRAL_REWARD, { company_id: companyId, rewarded }, callback);
};

/**
 * Indique e ganhe: lança agora no Stripe o crédito de quem indicou esta conta.
 * @param {number} companyId conta indicada
 * @param {Function} callback recebe { success, referral } ou { success: false, error }
 */
export const ApplyAdminCompanyReferralCreditAPI = (companyId, callback) => {
    callPostJson(ADMIN_COMPANIES_REFERRAL_REWARD, { company_id: companyId, apply: true }, callback);
};

/**
 * Indique e ganhe: confirma que esta conta veio de uma indicação direta (contato da Prospecção).
 * @param {number} companyId conta indicada
 * @param {Function} callback recebe { success, referral } ou { success: false, error }
 */
export const ConfirmAdminCompanyReferralAPI = (companyId, callback) => {
    callPostJson(ADMIN_COMPANIES_REFERRAL_CONFIRM, { company_id: companyId }, callback);
};

/**
 * Dados de exemplo: cria os exemplos da área numa conta em teste que ainda não recebeu.
 * @param {number} companyId
 * @param {Function} callback recebe { success, counts, demo_data } ou { success: false, code, error }
 */
export const SeedAdminCompanyDemoDataAPI = (companyId, callback) => {
    callPostJson(ADMIN_COMPANIES_DEMO_SEED, { company_id: companyId }, callback);
};

/**
 * Dados de exemplo: remove tudo o que é exemplo da conta (motivo "admin"). Irreversível.
 * @param {number} companyId
 * @param {Function} callback recebe { success, counts, demo_data } ou { success: false, code, error }
 */
export const RemoveAdminCompanyDemoDataAPI = (companyId, callback) => {
    callPostJson(ADMIN_COMPANIES_DEMO_REMOVE, { company_id: companyId }, callback);
};

/**
 * Prospecção: lista os contatos do catálogo. view "today" = fila do dia (traz sent_today).
 * @param {{ q?: string, category?: string, status?: string, source?: string, city?: string, view?: string, limit?: number }} params
 * @param {Function} callback recebe { success, items, sent_today? }
 */
export const GetAdminProspectsAPI = (params = {}, callback) => {
    callGet(ADMIN_PROSPECTS_LIST + buildQuery(params), callback);
};

/**
 * Prospecção: cria (sem id) ou altera um contato.
 * @param {Object} payload
 * @param {Function} callback recebe { success, item } ou { success: false, error, duplicate? }
 */
export const SaveAdminProspectAPI = (payload, callback) => {
    callPostJson(ADMIN_PROSPECTS_SAVE, payload, callback);
};

/**
 * Prospecção: mensagens já mandadas a um contato.
 * @param {number} prospectId
 * @param {Function} callback recebe { success, items }
 */
export const GetAdminProspectMessagesAPI = (prospectId, callback) => {
    callGet(ADMIN_PROSPECTS_MESSAGES + buildQuery({ prospect_id: prospectId }), callback);
};

/**
 * Prospecção: registra a mensagem mandada pelo aparelho do admin.
 * @param {{ prospect_id: number, channel: string, message: string, variant?: string }} payload
 * @param {Function} callback recebe { success, item }
 */
export const LogAdminProspectMessageAPI = (payload, callback) => {
    callPostJson(ADMIN_PROSPECTS_LOG_MESSAGE, payload, callback);
};

/**
 * Prospecção: envia pelo número da Gabriela e registra (só grava se a Z-API aceitou).
 * @param {{ prospect_id: number, message: string, variant?: string }} payload
 * @param {Function} callback recebe { success, item }
 */
export const SendAdminProspectWhatsAppAPI = (payload, callback) => {
    callPostJson(ADMIN_PROSPECTS_SEND_WHATSAPP, payload, callback);
};

/**
 * Prospecção: muda a situação de vários contatos de uma vez (fila do dia).
 * @param {{ prospect_ids: number[], status: string }} payload
 * @param {Function} callback recebe { success, changed, items }
 */
export const SetAdminProspectsStatusAPI = (payload, callback) => {
    callPostJson(ADMIN_PROSPECTS_SET_STATUS, payload, callback);
};

/**
 * Prospecção: busca profissionais no Google Maps (não grava nada).
 * @param {{ category: string, city: string, term?: string, page_token?: string }} payload
 * @param {Function} callback recebe { success, query, items, next_page_token }
 */
export const SearchAdminProspectPlacesAPI = (payload, callback) => {
    callPostJson(ADMIN_PROSPECTS_SEARCH_PLACES, payload, callback);
};

/**
 * Prospecção: põe no catálogo os lugares escolhidos na busca.
 * @param {{ category: string, items: Array }} payload
 * @param {Function} callback recebe { success, items, skipped }
 */
export const ImportAdminProspectsAPI = (payload, callback) => {
    callPostJson(ADMIN_PROSPECTS_IMPORT, payload, callback);
};
